<template>
  <div class="integral-details" ref="container">
    <div class="header">
      <div class="currentScore">当前积分</div>
      <div>{{ info.integral }}</div>
      <div class="line"></div>
      <div class="nav acea-row">
        <div class="item">
          <div class="num">{{ info.sum_integral }}</div>
          <div>累计积分</div>
        </div>
        <div class="item">
          <div class="num">{{ info.deduction_integral }}</div>
          <div>累计消费</div>
        </div>
        <div class="item">
          <div class="num">{{ info.today_integral }}</div>
          <div>今日获得</div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="nav acea-row">
        <div
          class="item acea-row row-center-wrapper"
          :class="current === index ? 'on' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="nav(index)"
        >
          <span class="iconfont" :class="item.icon">
            <img
              v-if="current != index && index === 0"
              src="@assets/images/jf_no.png"
            />
            <img
              v-if="current === index && index === 0"
              src="@assets/images/jf.png"
            /> </span
          >{{ item.name }}
        </div>
      </div>
      <div class="list" :hidden="current !== 1">
        <!--        <div class="tip acea-row row-middle">-->
        <!--          <span class="iconfont icon-shuoming"></span-->
        <!--          >提示：积分数值的高低会直接影响您的会员等级-->
        <!--        </div>-->
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in list"
          :key="index"
        >
          <div>
            <div class="state">{{ item.mark }}</div>
            <div>{{ item.add_time }}</div>
          </div>
          <div class="num" v-if="item.pm == 1">+{{ item.number }}</div>
          <div class="num font-color-red" v-if="item.pm == 0">
            -{{ item.number }}
          </div>
        </div>
      </div>
      <div class="list2" :hidden="current !== 0">
        <div style="background-color: #fff;padding: 0rem 0.3rem;">
          <div
            style="font-size: 0.25rem;width: 6.9rem;height: 0.7rem;border-radius: 0.5rem;background-color: #fff5e2;
    border: 1px solid #ffeac1;color: #c8a86b;padding: 0 0.2rem;margin-bottom: 0.24rem;"
          >
            消耗{{
              vouchersConsume
            }}积分，可参与抽取抵用券一次。抵用券面额分别为{{
              vouchers
            }}，随机中奖，多抽多中。
          </div>
          <div
            @click="luckDraw"
            class="cj"
            style="width: 150px;height: 150px;line-height: 150px;margin: 90px auto;border-radius: 50% / 50%;text-align: center;    font-size: 18px;
    color: #ffffff;"
          >
            {{ vouchersConsume }}分抽一次
          </div>
        </div>

        <!--        <router-link class="item acea-row row-between-wrapper" :to="'/'">-->
        <!--          <div class="pictrue"><img src="@assets/images/score.png" /></div>-->
        <!--          <div class="name">购买商品可获得积分奖励</div>-->
        <!--          <div class="earn">赚积分</div>-->
        <!--        </router-link>-->
        <!--        <router-link-->
        <!--          class="item acea-row row-between-wrapper"-->
        <!--          :to="'/user/sign'"-->
        <!--        >-->
        <!--          <div class="pictrue"><img src="@assets/images/score.png" /></div>-->
        <!--          <div class="name">每日签到可获得积分奖励</div>-->
        <!--          <div class="earn">赚积分</div>-->
        <!--        </router-link>-->
      </div>
    </div>
    <div class="sign">
      <div
        class="signTip acea-row row-center-wrapper"
        :class="active === true ? 'on' : ''"
      >
        <div class="signTipLight loadingpic"></div>
        <div :class="code && code != -1 ? 'signTipCon' : 'cjbg'">
          <div class="state">{{ state }}</div>
          <div class="integral">{{ integral }}</div>
          <div class="signTipBnt" @click="close">好的</div>
        </div>
      </div>
      <div class="mask" @touchmove.prevent :hidden="active === false"></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import {
  getIntegralList,
  postSignUser,
  getConfigure,
  luckDraw
} from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "Integral",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      navList: [
        { name: "积分抽奖", icon: "" },
        { name: "分值明细", icon: "icon-mingxi" }
        // { name: "分值提升", icon: "icon-tishengfenzhi" }
      ],
      current: 0,
      where: {
        page: 1,
        limit: 15
      },
      data: {
        sign: 1,
        integral: 1,
        all: 1
      },
      list: [],
      info: [],
      loaded: true,
      loading: false,
      vouchersConsume: "",
      vouchers: "",
      active: false,
      state: "",
      integral: "",
      code: 0
    };
  },
  mounted: function() {
    this.getConfigure();
    this.getIntegral();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getInfo();
    });
  },
  methods: {
    luckDraw: function() {
      let that = this;
      luckDraw().then(
        res => {
          that.getIntegral();
          this.active = true;
          this.code = res.data.result;
          if (res.data.result != -1) {
            this.state = "恭喜您";
            this.integral = "获得" + res.data.result + "元抵用券";
          } else {
            this.state = "很可惜";
            this.integral = "未中奖";
          }
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    close: function() {
      this.active = false;
    },
    getConfigure: function() {
      let that = this;
      getConfigure().then(
        res => {
          that.vouchersConsume = res.data.vouchers_consume;
          that.vouchers = res.data.vouchers.join("、");
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    nav: function(index) {
      let that = this;
      this.current = index;
      this.loaded = true;
      if (index === 1) {
        this.list = [];
        this.loaded = false;
        this.where = {
          page: 1,
          limit: 15
        };
        getIntegralList(that.where).then(
          res => {
            that.loading = false;
            that.loaded = res.data.length < that.where.limit;
            that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
            that.where.page = that.where.page + 1;
            that.list.push.apply(that.list, res.data);
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
      }
    },
    getInfo: function() {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      getIntegralList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.list.push.apply(that.list, res.data);
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    getIntegral: function() {
      let that = this;
      postSignUser(that.data).then(
        res => {
          that.info = res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    }
  }
};
</script>
<style>
.cj {
  background: url("../../../assets/images/cj.png") no-repeat;
  background-size: 100% 100%;
}
.cjbg {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 4.2rem;
  height: 4.2rem;
  margin-top: -7rem;
  position: relative;
  background-image: url("../../../assets/images/failed.png");
}

.sign .signTip .cjbg .state{font-size:0.34rem;color:#fff;margin-top:1.5rem;}
.sign .signTip .cjbg .integral{font-size:0.3rem;color:rgba(255,255,255,0.6);margin-top:0.09rem;}
.sign .signTip .cjbg .signTipBnt{font-size:0.3rem;color:#eb4331;width:2.6rem;height:0.76rem;background-color:#f8d168;border-radius:0.38rem;line-height:0.76rem;margin:0.48rem auto 0 auto;}
</style>
